<template>
    <div class="button-wrapper">
        <a 
        :href="url"
        target="_blank"
        class="base-button"
        :class="{ 'hover-effect': enableHover, 'default-theme': theme === 'default', 'primary-theme': theme === 'primary' }"
        :style="buttonStyle"
        v-if="url != ''"
        >
        <slot>{{ text }}</slot>
      </a>
      <button 
        class="base-button"
        :class="{ 'hover-effect': enableHover, 'default-theme': theme === 'default', 'primary-theme': theme === 'primary' }"
        :style="buttonStyle"
        v-else
        >
        <slot>{{ text }}</slot>
      </button>
    </div>
  </template>
  
  <script setup>
    import { computed } from 'vue';
    
    const props = defineProps({
      text: {
        type: String,
        default: ''
      },
      enableHover: {
        type: Boolean,
        default: true
      },
      theme: {
        type: String,
        default: 'default'
      },
      url:{
        type: String,
        default: 'default'
      }
    });
    
    // defineEmits(['click']);
    
    // 定义 buttonStyle
    const buttonStyle = computed(() => {
      // 根据需要返回样式对象
      return {
        // 例如，动态设置背景色
        backgroundColor: props.theme === 'primary' ? 'transparent' : '#fff',
        color: props.theme === 'primary' ? '#fff' : '#333'
      };
    });
    </script>
  
  <style scoped>
    
    .button-wrapper{
        height: 50px;
        display: flex;
        justify-self: center;
        align-items:center;
        margin: 0 auto;
    }
  .base-button {
    width: 400px;
    height: 50px;
    padding: 0 40px;
    background-color: #fff;
    border: 2px solid #1d1d1f;
    border-radius: 25px; /* 50% 的圆角 */
    font-size: 14px;
    font-weight: bold;
    color: #1d1d1f;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    outline: none;
    white-space: nowrap;
    margin:0 auto;
  }
  
  /* .base-button.hover-effect:hover { */
    /* background-color: #017af9; */
    /* color: #fff; */
    /* transform: translateY(-2px); */
    /* border: 2px solid #017af9;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  /* } */
  
  /* .base-button:active {
    transform: translateY(0);
  } */
  .base-button.default-theme {
        background-color: #fff;
        border: 2px solid #1d1d1f;
        color: #1d1d1f;
    }
    .base-button.primary-theme {
        background-color: transparent;
        border: 2px solid #fff;
        color: #fff;
    }
    /* .base-button.hover-effect:hover {
    background-color: #017af9;
    color: #fff; */
    /* transform: translateY(-2px); */
    /* border: 2px solid #017af9;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  } */
  
  @media screen and (max-width: 768px) {
    .base-button {
      min-width: 160px;
      height: 44px;
      padding: 0 30px;
      font-size: 14px;
    }
    .button-wrapper{
      height: 44px;
      width: 87.5vw;
    }
  }
  </style>